// import axios from "axios";
import { post, fetchLang, axiosLang } from "../util/http";
// import axios from 'axios';

// 文件查询
export function getCloudDiskList(params, lang) {
	if (!lang) {
		return post('/api/cloud/getList', params)
	}
	return fetchLang('/api/cloud/getList', {
		method: "POST",
		headers,
		body: JSON.stringify(params)
	}, lang).then(res => res.json())
}

//查询同级别下名字文件-文件夹是否存在
export function getCloudSearch(params) {
	return post('/api/cloud/search', params)
}

//文件上传(带文件夹)
export function createWithFolders(params) {
	return post('/api/cloud/createWithFolders', params)
}

//批量删除
export function batchTrash(params) {
	return post('/api/cloud/batchTrash', params)
}

//判断文件是否存在有效产品关联
export function existsByFileIds(params) {
	return post('/api/cloudFileProductReference/existsByFileIds', params)
}

//文件夹重命名
export function updateFolder(params) {
	return post('/api/cloud/updateFolder', params)
}

//文件重命名
export function updateFile(params) {
	return post('/api/cloud/updateFile', params)
}

//批量移动
export function batchMove(params) {
	return post('/api/cloud/batchMove', params)
}

//查询云盘容量信息
export function cloudCount(params) {
	return post('/api/cloud/count', params)
}

//文件覆盖
export function coverFile(params) {
	return post('/api/cloud/coverFile', params)
}

//查询剩余容量
export function cloudLeft(params) {
	return post('/api/cloud/left', params)
}

//添加原图文件到指定的文件夹中(保存作品库的作品展览原图到云盘) 指定的文件夹 1-作品展览原图 2-获奖证书 必传字段: type|wid|name|owner|fileType|size|obsUrl|coverUrl
export function copyOriginToCloud(params) {
	return post('api/cloud/copyOriginToCloud', params)
}
const headers = {
	"content-type": "application/json"
}

// 条件查询团队容量列表
export function queryByCon(params) {
	return fetchLang('/api/teamCapacity/queryByCon', {
		method: "POST",
		headers,
		body: JSON.stringify(params)
	}).then(res => res.json())
}
// 查询购买指定套餐后的团队总容量
export function queryTotalCapacity(params) {
	return fetchLang('/api/teamCapacity/queryTotalCapacity?' + new URLSearchParams(params).toString(), {
		method: "GET",
		headers,
	}).then(res => res.json())
}
// 赠送商品
export function giveAsPresent(params) {
	return fetchLang('/api/payOrder/giveAsPresent', {
		method: "POST",
		headers,
		body: JSON.stringify(params)
	}).then(res => res.json())
}
// 取消赠送商品
export function callOffGiveAsPresent(params) {
	return fetchLang('/api/payOrder/callOffGiveAsPresent', {
		method: "POST",
		headers,
		body: JSON.stringify(params)
	}).then(res => res.json())
}
// 查询订单列表
export function queryPayOrder(params) {
	return fetchLang('/api/payOrder/query', {
		method: "POST",
		headers,
		body: JSON.stringify(params)
	}).then(res => res.json())
}
// 申请发票
export function applyForInvoice(params) {
	return fetchLang('/api/invoiceTitle/applyForInvoice', {
		method: "POST",
		headers,
		body: JSON.stringify(params)
	}).then(res => res.json())
}
// 条件查询云盘套餐列表
export function queryByConCloud(params) {
	return fetchLang('/api/cloudProduct/queryByCon', {
		method: "POST",
		headers,
		body: JSON.stringify(params)
	}).then(res => res.json())
}
// 创建云盘套餐
export function createByConCloud(params) {
	return fetchLang('/api/cloudProduct/create', {
		method: "POST",
		headers,
		body: JSON.stringify(params)
	}).then(res => res.json())
}
// 删除单个云盘套餐
export function delByConCloud(id) {
	return fetchLang('/api/cloudProduct/deleteById/' + id, {
		method: "PUT",
	}).then(res => res.json())
}
// 修改云盘套餐
export function updateByConCloud(params) {
	return fetchLang('/api/cloudProduct/update', {
		method: "PUT",
		headers,
		body: JSON.stringify(params)
	}).then(res => res.json())
}
// 拖动排序云盘
export function moveNo(params) {
	return fetchLang('/api/cloudProduct/moveNo', {
		method: "PUT",
		headers,
		body: JSON.stringify(params)
	}).then(res => res.json())
}

// 分页查询云盘权益
export function queryCloudEntitlements(params) {
	return fetchLang('/api/admin/cloud-entitlements/query', {
		method: 'POST',
		headers,
		body: JSON.stringify(params)
	}).then(res => res.json())
}

// 查询云盘权益详情
export function getCloudEntitlementDetail(id) {
	return fetchLang(`/api/admin/cloud-entitlements/${encodeURIComponent(id)}`, {
		method: 'GET',
		headers,
	}).then(res => res.json())
}

// 新增云盘权益
export function createCloudEntitlement(params) {
	return fetchLang('/api/admin/cloud-entitlements/create', {
		method: 'POST',
		headers,
		body: JSON.stringify(params)
	}).then(res => res.json())
}

// 修改云盘权益及启用状态
export function updateCloudEntitlement(params) {
	return fetchLang('/api/admin/cloud-entitlements/update', {
		method: 'POST',
		headers,
		body: JSON.stringify(params)
	}).then(res => res.json())
}

// 逻辑删除云盘权益
export function deleteCloudEntitlement(params) {
	return fetchLang('/api/admin/cloud-entitlements/delete', {
		method: 'POST',
		headers,
		body: JSON.stringify(params)
	}).then(res => res.json())
}

// 分页查询管理端云盘套餐
export function queryAdminCloudProducts(params) {
	return fetchLang('/api/admin/cloud-products/query', {
		method: 'POST',
		headers,
		body: JSON.stringify(params)
	}).then(res => res.json())
}

// 查询管理端云盘套餐详情
export function getAdminCloudProductDetail(id) {
	return fetchLang(`/api/admin/cloud-products/${encodeURIComponent(id)}`, {
		method: 'GET',
		headers,
	}).then(res => res.json())
}

// 新增管理端云盘套餐
export function createAdminCloudProduct(params) {
	return fetchLang('/api/admin/cloud-products/create', {
		method: 'POST',
		headers,
		body: JSON.stringify(params)
	}).then(res => res.json())
}

// 修改管理端云盘套餐
export function updateAdminCloudProduct(params) {
	return fetchLang('/api/admin/cloud-products/update', {
		method: 'POST',
		headers,
		body: JSON.stringify(params)
	}).then(res => res.json())
}

// 复制管理端云盘套餐
export function copyAdminCloudProduct(params) {
	return fetchLang('/api/admin/cloud-products/copy', {
		method: 'POST',
		headers,
		body: JSON.stringify(params)
	}).then(res => res.json())
}

// 逻辑删除管理端云盘套餐
export function deleteAdminCloudProduct(params) {
	return fetchLang('/api/admin/cloud-products/delete', {
		method: 'POST',
		headers,
		body: JSON.stringify(params)
	}).then(res => res.json())
}

// 调整管理端云盘套餐顺序
export function moveAdminCloudProduct(params) {
	return fetchLang('/api/admin/cloud-products/move', {
		method: 'POST',
		headers,
		body: JSON.stringify(params)
	}).then(res => res.json())
}

// 批量配置管理端云盘套餐权益
export function batchConfigAdminCloudProducts(params) {
	return fetchLang('/api/admin/cloud-products/batch-config', {
		method: 'POST',
		headers,
		body: JSON.stringify(params)
	}).then(res => res.json())
}

// 分页查询管理端支付成功订单
export function queryAdminPayOrders(params) {
	return fetchLang('/api/admin/pay-orders/query', {
		method: 'POST',
		headers,
		body: JSON.stringify(params)
	}).then(res => res.json())
}

//压缩图片
// resizePix：300, // 短边尺寸
// resolution: 100，// dpi值，
// quality: 80 // 图像压缩质量
export function compressImage(params) {
	return post('/api/compress_image', params)
}

//查询文件夹大小
export function getFolderSize(params) {
	return post('/api/cloud/getFolderSize', params)
}
// 查询弹框消息列表
export function queryPopUpMsg(params) {
	return post('/api/pushTemplate/queryPopUpMsg', params)
}

// 标记弹框消息已确认
export function markPopUpRead(params) {
	return fetchLang('/api/pushTemplate/markPopUpRead', {
		method: "PUT",
		headers,
		body: JSON.stringify(params)
	}).then(res => res.json())
}

// 查询 不觉下载器
export async function getCloudDiskListByPage() {
	const axios = axiosLang();
	return axios.get('/api/fileDownloader/findOne',)
}

// 根据任务 文件或者夹的id 生成一个后端的任务id
export async function createBackendTaskId(params) {
	const axios = axiosLang();
	return axios.post('/api/cloud/downloadPre', params)
}

// 根据任务id查询这个任务有没有被消费即可
export async function taskIdGenerator(key) {
	const axios = axiosLang();
	return await axios.get('/api/cloud/getDownloadStatus?' + `key=${key}`)
}


// 根据任务id查询这个任务有没有被消费即可
export async function fileDownloaderSave(params) {
	const axios = axiosLang();
	return await axios.post('/api/fileDownloader/save',params)
}

// 根据任务id查询这个任务有没有被消费即可
export function downloadPreByWeb(params) {
	return fetchLang('/api/cloud/downloadPreByWeb', {
		method: "POST",
		headers,
		body: JSON.stringify(params)
	}).then(res => res.json())
}

// 批量图片压缩-生成四张压缩图
export function batchUploadImgNewInQueue(params) {
	return fetchLang('/api/batchUploadImgNewInQueue', {
		method: "POST",
		headers,
		body: JSON.stringify(params)
	}).then(res => res.json())
}

  // 素材库创建文件夹及文件
export function createThroughImagesLib(params) {
	return fetchLang('/api/cloud/createThroughImagesLib', {
		method: "POST",
		headers,
		body: JSON.stringify(params)
	}).then(res => res.json())
}

  // 获取云盘贴图库
  export function getTreeThroughImagesLib(params) {
	return fetchLang('/api/cloud/getTreeThroughImagesLib', {
		method: "POST",
		headers,
		body: JSON.stringify(params)
	}).then(res => res.json())
}
//查询套餐剩余天数
export function findTeamCapacityStatusInfoAndSetRead(params) {
	return fetchLang(
		"/api/teamCapacity/findTeamCapacityStatusInfoAndSetRead?" + new URLSearchParams(params).toString(),
		{
		method: "GET",
		headers,
		}
	).then((res) => res.json());
}
